import { computed } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import fetchData from '@/util/fetch'

// Config projects, fetched once and cached; shared by every component that
// needs to resolve a project id to its name
export default function useConfigProjects() {
  const query = useQuery({
    queryKey: ['configProjects'],
    queryFn: () => fetchData('/config/api/v1/projects/'),
    staleTime: 5 * 60 * 1000,
  })

  const projects = computed(() => query.data?.value?.data || [])

  const projectNamesById = computed(() => {
    const names = {}
    for (const project of projects.value) {
      names[project.id] = project.name
    }
    return names
  })

  return { projects, projectNamesById }
}
